export default {
  geolocation: {
    lat: '37.9838',
    lng: '23.7278',
    label: '101 22 Athens',
  },
  price_rules: {
    grouping: '.',
    decimal: ',',
  },
}
